import React from 'react';
import { Redirect } from 'react-router-dom';
import { useCurrentUser } from '../../Session';
import { UserType } from '../../api';
import BasicLayout from '../../layouts/BasicLayout';
import { MyBids } from '../../pages/DealerBiddings';

const MyBidsRoute = () => {
    const currentUser = useCurrentUser();

    if (currentUser.type !== UserType.Dealer) {
        return <Redirect to="/403" />;
    }

    return (
        <BasicLayout>
            <MyBids />
        </BasicLayout>
    );
};

export default MyBidsRoute;
